import {ClassificationFieldExternalId} from "./classification-field-externalid";
import {ClassificationFieldTranslation} from "./classification-field-translation";
import {ClassificationGroup} from "./classification-group";
import {ClassificationType} from "./classification-type";

export class ClassificationField {

  public id: string;
  public key: string;
  public value: any;
  public classificationType: ClassificationType;
  public childClassificationType: ClassificationType;
  public translations: ClassificationFieldTranslation[] = [];
  public customOrder: number;
  public classificationGroups: ClassificationGroup[] = [];
  public determinantId: string;
  public classificationTypeId: string;
  public useCustomKey: boolean;
  public classificationFieldExternalIdList: ClassificationFieldExternalId[] = [];
  public type: string;
  public catalogLevel: number;
  public relationKey: string;
  public sayRejectionReason: boolean = false;
}
